import { useDOMPurify } from '../../lib/useDOMPurify';

interface FeatureProps {
	imageUrl: string;
	title: string;
	description: string;
	showTitle: boolean;
	maxWidth: boolean;
}

const Feature = ({ description, imageUrl, title, showTitle, maxWidth }: FeatureProps) => {
	const sanitizedContent = useDOMPurify(description);

	return (
		<div className={`flex flex-col min-w-[274px] ${maxWidth ? 'max-w-[274px]': ''} h-full lg:flex-row min-h-[449px] max-h-[449px] bg-secondary-lemon rounded-[16px]`}>
			{imageUrl && (
				<div
					className={`flex justify-center w-full bg-primary-violet rounded-[16px] h-[250px] lg:max-h-full lg:h-full`}
				>
					<img className="object-contain rounded-[16px]" src={imageUrl}></img>
				</div>
			)}

			{description && (
				<div className="mx-4 my-3 px-4 py-3 w-auto md:w-full h-auto overflow-y-auto scrollbar-thin">
					{showTitle ? <h2 className="text-2xl mb-6">{title}</h2> : null}

					<span dangerouslySetInnerHTML={{ __html: sanitizedContent }}></span>
				</div>
			)}
		</div>
	);
};

export default Feature;
